// 前端menuId 并不是所有前端路由都有menuId，但是某些情况下前端需要路由具有指定id
// 从10000开始算

// 活动管理下的活动详情
const ACTIVITY_MANAGE_ACTIVITY_DETAIL = 10001;
// 活动管理下的活动详情/商品池
const ACTIVITY_MANAGE_ACTIVITY_DETAIL_GOODS_POOL = 10002;
// 活动管理下的活动详情/氛围权益
const ACTIVITY_MANAGE_ACTIVITY_DETAIL_TAG = 10003;
// 活动管理下的活动详情/会场运营
const ACTIVITY_MANAGE_ACTIVITY_DETAIL_ROOM = 10004;
// 活动管理下的活动详情/综促活动
const ACTIVITY_MANAGE_ACTIVITY_DETAIL_ZONGCU = 10005;
// 活动管理下的活动详情/活动管理
const ACTIVITY_MANAGE_ACTIVITY_DETAIL_ACTIVITY_MANAGE = 10006;
// 频道业务>具体频道活动列表>活动详情
const CHANNEL_ACTIVITYLIST_DETAIL = 10100;

// 招商活动详情
const MERCHANT_ACTIVITY_DETAIL = 10200;
//活动流程数据
const MERCHANT_ACTIVITY_DETAIL_DATA = 10210;
// 招商底池
const MERCHANT_ACTIVITY_DETAIL_WARE = 10201;
// 主推品盘货
const MERCHANT_ACTIVITY_DETAIL_INVENTORY = 10202;
// 会场选品
const MERCHANT_ACTIVITY_DETAIL_SELECTION = 10209;
// 我的商品
const MERCHANT_ACTIVITY_DETAIL_MYWARE = 10203;
// 会场活动
const MERCHANT_ACTIVITY_DETAIL_ROOM = 10204;
// 会场素材池
/**/ const MERCHANT_ACTIVITY_DETAIL_ROOM_MATERIAL = 102043;
// 素材底池
/**/ const MERCHANT_ACTIVITY_DETAIL_MATERIAL = 102041;
// 部门所有会场
/**/ const MERCHANT_ACTIVITY_DETAIL_ALLROOM = 102042;
// 促销活动
const MERCHANT_ACTIVITY_DETAIL_PROMOTION = 10206;
// 部门所有活动
/**/ const MERCHANT_ACTIVITY_DETAIL_ALLPROMOTION = 102061;
// 我的商家
const MERCHANT_ACTIVITY_DETAIL_MYSHOP = 10208;
//活动流程数据
const MERCHANT_ACTIVITY_DETAIL_DATA_CALENDAR = 10212;
//活动信息
const MERCHANT_ACTIVITY_DETAIL_INFO = 10205;
// 我管理的会场池
const MERCHANT_ACTIVITY_DETAIL_ROOMPOOL = 102081;
// 我参与的会场池
const MERCHANT_ACTIVITY_DETAIL_ROOMPOOLPARTICIPATE = 102082;

// 注入身份被允许的路由
function injectMenus(menus) {
  const _menus = menus.slice();
  _menus.push(
    {
      menuId: ACTIVITY_MANAGE_ACTIVITY_DETAIL,
      createTime: 1602328395000,
      menuName: '活动详情',
      menus: [],
      parentId: -1,
      status: 1,
      updateTime: 1602328399000,
    },
    {
      menuId: PLATFORM_MARKETING_DETAIL,
      createTime: 1602328395000,
      menuName: '平台营销阵地详情',
      menus: [],
      parentId: -1,
      status: 1,
      updateTime: 1602328399000,
    },
    {
      menuId: PLATFORM_RESOURCE_DETAIL,
      createTime: 1602328395000,
      menuName: '资源位详情',
      menus: [],
      parentId: -1,
      status: 1,
      updateTime: 1602328399000,
    },
    {
      menuId: PLATFORM_MATERIAL_COLLECTION,
      createTime: 1602328395000,
      menuName: '素材收选详情页',
      menus: [],
      parentId: -1,
      status: 1,
      updateTime: 1602328399000,
    },
    {
      menuId: DAILY_ACTIVITY_MATERIAL,
      createTime: 1602328395000,
      menuName: '素材收选日常活动',
      menus: [],
      parentId: -1,
      status: 1,
      updateTime: 1602328399000,
    },
    {
      menuId: DAILY_ACTIVITY_MANAGE,
      createTime: 1602328395000,
      menuName: '素材管理日常活动',
      menus: [],
      parentId: -1,
      status: 1,
      updateTime: 1602328399000,
    }
  );

  return _menus;
}

// 活动管理/活动详情的子路由
const ACTIVITY_MANAGE_DETAIL_SUB_MENUS = [
  {
    menuId: ACTIVITY_MANAGE_ACTIVITY_DETAIL_GOODS_POOL,
    createTime: 1602328395000,
    menuName: '商品池',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: ACTIVITY_MANAGE_ACTIVITY_DETAIL_TAG,
    createTime: 1602328395000,
    menuName: '氛围权益',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: ACTIVITY_MANAGE_ACTIVITY_DETAIL_ACTIVITY_MANAGE,
    createTime: 1602328395000,
    menuName: '子活动活动管理',
    menus: [
      {
        menuId: ACTIVITY_MANAGE_ACTIVITY_DETAIL_ROOM,
        createTime: 1602328395000,
        menuName: '会场运营',
        menus: [],
        parentId: -1,
        status: 1,
        updateTime: 1602328399000,
      },
      {
        menuId: ACTIVITY_MANAGE_ACTIVITY_DETAIL_ZONGCU,
        createTime: 1602328395000,
        menuName: '综促活动',
        menus: [],
        parentId: -1,
        status: 1,
        updateTime: 1602328399000,
      },
    ],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: CHANNEL_ACTIVITYLIST_DETAIL,
    createTime: 1602328395000,
    menuName: '活动详情',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
];

const MERCHANT_ACTIVITY_DETAIL_SUB_MENUS = [
  {
    menuId: MERCHANT_ACTIVITY_DETAIL_INFO,
    createTime: 1602328395000,
    menuName: '活动信息',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: MERCHANT_ACTIVITY_DETAIL_DATA_CALENDAR,
    createTime: 1602328395000,
    menuName: '数据中心',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: MERCHANT_ACTIVITY_DETAIL_DATA,
    createTime: 1602328395000,
    menuName: '活动流程数据',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: MERCHANT_ACTIVITY_DETAIL_WARE,
    createTime: 1602328395000,
    menuName: '招商底池',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: MERCHANT_ACTIVITY_DETAIL_INVENTORY,
    createTime: 1602328395000,
    menuName: '主推品盘货',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: MERCHANT_ACTIVITY_DETAIL_SELECTION,
    createTime: 1602328395000,
    menuName: '会场选品',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: MERCHANT_ACTIVITY_DETAIL_MYWARE,
    createTime: 1602328395000,
    menuName: '我的商品',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: MERCHANT_ACTIVITY_DETAIL_ROOM,
    createTime: 1602328395000,
    menuName: '会场活动',
    menus: [
      {
        menuId: MERCHANT_ACTIVITY_DETAIL_ROOMPOOL,
        createTime: 1650456107000,
        menuName: '我管理的会场池',
        menus: [],
        parentId: -1,
        status: 1,
        updateTime: 1650456107000,
      },
      {
        menuId: MERCHANT_ACTIVITY_DETAIL_ROOMPOOLPARTICIPATE,
        createTime: 1650456107000,
        menuName: '我参与的会场池',
        menus: [],
        parentId: -1,
        status: 1,
        updateTime: 1650456107000,
      },
      {
        menuId: MERCHANT_ACTIVITY_DETAIL_MATERIAL,
        createTime: 1602328395000,
        menuName: '分会场素材底池',
        menus: [],
        parentId: -1,
        status: 1,
        updateTime: 1650456107000,
      },
      {
        menuId: MERCHANT_ACTIVITY_DETAIL_ROOM_MATERIAL,
        createTime: 1602328395000,
        menuName: '素材底池',
        menus: [],
        parentId: -1,
        status: 1,
        updateTime: 1602328399000,
      },
      {
        menuId: MERCHANT_ACTIVITY_DETAIL_ALLROOM,
        createTime: 1602328395000,
        menuName: '部门所有会场',
        menus: [],
        parentId: -1,
        status: 1,
        updateTime: 1602328399000,
      },
    ],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: MERCHANT_ACTIVITY_DETAIL_PROMOTION,
    createTime: 1602328395000,
    menuName: '促销活动',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
    menus: [
      {
        menuId: MERCHANT_ACTIVITY_DETAIL_ALLPROMOTION,
        createTime: 1602328395000,
        menuName: '素材底池',
        menus: [],
        parentId: -1,
        status: 1,
        updateTime: 1602328399000,
      },
      {
        menuId: MERCHANT_ACTIVITY_DETAIL_ROOM_MATERIAL,
        createTime: 1602328395000,
        menuName: '会场素材池',
        menus: [],
        parentId: -1,
        status: 1,
        updateTime: 1602328399000,
      },
    ],
  },
  {
    menuId: MERCHANT_ACTIVITY_DETAIL_MYSHOP,
    createTime: 1602328395000,
    menuName: '我的商家',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
];

// 趋势运营 趋势管理START
// 趋势主张
const TREND_MANAGE_IDEA = 20101;
// 趋势场景
const TREND_MANAGE_SITUATION = 20102;
// 趋势品类
const TREND_MANAGE_CATEGORY = 20103;
// 业务场域
const TREND_MANAGE_FIELD = 20104;
// 趋势运营 趋势管理END

const TREND_MANAGE_SUB_MENUS = [
  {
    menuId: TREND_MANAGE_IDEA,
    createTime: 1602328395000,
    menuName: '趋势主张',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: TREND_MANAGE_SITUATION,
    createTime: 1602328395000,
    menuName: '趋势场景',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: TREND_MANAGE_CATEGORY,
    createTime: 1602328395000,
    menuName: '趋势品类',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
  {
    menuId: TREND_MANAGE_FIELD,
    createTime: 1602328395000,
    menuName: '业务场域',
    menus: [],
    parentId: -1,
    status: 1,
    updateTime: 1602328399000,
  },
];

const PLATFORM_MARKETING_DETAIL = 40000;
const PLATFORM_RESOURCE_DETAIL = 10400;
const PLATFORM_MATERIAL_COLLECTION = 10401;
const DAILY_ACTIVITY_MATERIAL = 10402;
const DAILY_ACTIVITY_MANAGE = 10403;

export {
  TREND_MANAGE_IDEA,
  TREND_MANAGE_SITUATION,
  TREND_MANAGE_CATEGORY,
  TREND_MANAGE_FIELD,
  TREND_MANAGE_SUB_MENUS,
  ACTIVITY_MANAGE_ACTIVITY_DETAIL,
  ACTIVITY_MANAGE_ACTIVITY_DETAIL_GOODS_POOL,
  ACTIVITY_MANAGE_ACTIVITY_DETAIL_TAG,
  ACTIVITY_MANAGE_ACTIVITY_DETAIL_ROOM,
  ACTIVITY_MANAGE_ACTIVITY_DETAIL_ZONGCU,
  ACTIVITY_MANAGE_ACTIVITY_DETAIL_ACTIVITY_MANAGE,
  ACTIVITY_MANAGE_DETAIL_SUB_MENUS,
  MERCHANT_ACTIVITY_DETAIL,
  MERCHANT_ACTIVITY_DETAIL_INFO,
  MERCHANT_ACTIVITY_DETAIL_DATA,
  MERCHANT_ACTIVITY_DETAIL_DATA_CALENDAR,
  MERCHANT_ACTIVITY_DETAIL_WARE,
  MERCHANT_ACTIVITY_DETAIL_INVENTORY,
  MERCHANT_ACTIVITY_DETAIL_SELECTION,
  MERCHANT_ACTIVITY_DETAIL_MYWARE,
  MERCHANT_ACTIVITY_DETAIL_MATERIAL,
  MERCHANT_ACTIVITY_DETAIL_ROOM,
  MERCHANT_ACTIVITY_DETAIL_ROOM_MATERIAL,
  MERCHANT_ACTIVITY_DETAIL_ALLROOM,
  MERCHANT_ACTIVITY_DETAIL_PROMOTION,
  MERCHANT_ACTIVITY_DETAIL_ALLPROMOTION,
  MERCHANT_ACTIVITY_DETAIL_SUB_MENUS,
  MERCHANT_ACTIVITY_DETAIL_MYSHOP,
  CHANNEL_ACTIVITYLIST_DETAIL,
  PLATFORM_MARKETING_DETAIL,
  PLATFORM_RESOURCE_DETAIL,
  PLATFORM_MATERIAL_COLLECTION,
  DAILY_ACTIVITY_MATERIAL,
  DAILY_ACTIVITY_MANAGE,
  MERCHANT_ACTIVITY_DETAIL_ROOMPOOL,
  MERCHANT_ACTIVITY_DETAIL_ROOMPOOLPARTICIPATE,
  injectMenus,
};
